import { routes } from "./apps";
import { prefixRouteTree } from "./route.utils";
import { TRouteMap, TRouteName, TRoutes } from "./routes.types";

export const createRoutes = (app: TRouteName): TRouteMap =>
  Object.fromEntries(
    (Object.entries(routes) as [ TRouteName, TRoutes ][])
      .map(([ routeName, routeTree ]) => [
        routeName,
        routeName === app
          ? routeTree
          : prefixRouteTree(routeTree, routeName),
      ]),
  ) as TRouteMap;
